import { type JSX, splitProps } from "solid-js";
import { cn } from "~/util/utils";

interface CloseButtonProps extends JSX.HTMLAttributes<HTMLButtonElement> {}

export function CloseButton(props: CloseButtonProps) {
	const [local, other] = splitProps(props, ["class"]);
	return (
		<button
			class={cn(
				"absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none",
				local.class,
			)}
			aria-label="Dismiss"
			role="button"
			type="button"
			{...other}
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
				class="size-4"
			>
				<path d="M18 6l-12 12" />
				<path d="M6 6l12 12" />
			</svg>
			<span class="sr-only">Close</span>
		</button>
	);
}
